import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useState } from 'react';
import Icon from '../../Atoms/Icon';
import Text from '../../Atoms/Text';
import Title from '../../Atoms/Title';
import CardShare from '../../Molecules/CardShare';
import FormFile from '../../Molecules/FormFile';

interface Props {
  inline?: boolean;
  className?: string;
}

function BannerCV({ inline = false, className }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={className}>
      <CardShare
        title="Wil je snel aan de slag?"
        subTitle="Stuur jou cv en wij gaan op zoek naar een passende uitdaging!"
        inline={inline}
        button={{
          iconName: 'file-user',
          color: 'accent',
          text: 'Deel jouw cv',
          onClick: () => setIsOpen(true)
        }}
      />
      <Transition appear show={isOpen}>
        <Dialog onClose={() => setIsOpen(false)}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 z-[100] bg-sl-blue-dark bg-opacity-75 text-opacity-50" />
          </Transition.Child>
          <div className="fixed inset-0 z-[150] overflow-y-auto">
            <div className="flex min-h-full justify-center p-4">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 -translate-y-10"
                enterTo="opacity-100 translate-y-0"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 -translate-y-10"
              >
                <Dialog.Panel className="relative w-full max-w-md py-10">
                  <button
                    className="absolute top-0 right-0 flex h-10 w-10 items-center justify-center rounded-full bg-white text-base text-sl-blue"
                    type="button"
                    onClick={() => setIsOpen(false)}
                    aria-label="close modal"
                  >
                    <Icon icon="x-mark" />
                  </button>
                  <Dialog.Title
                    as="div"
                    className="pb-10 text-white"
                  >
                    <Title as="h3" color="inherit">
                      <span className="text-2xl">
                        Level up your job
                      </span>
                    </Title>
                    <Text size="sm" as="p" color="inherit">
                      Upload je CV en wij vinden de beste
                      baan voor jou.
                    </Text>
                  </Dialog.Title>
                  <FormFile />
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
}

export default BannerCV;
